import { render, staticRenderFns } from "./product.vue?vue&type=template&id=17637522&scoped=true&"
var script = {}
import style0 from "./product.vue?vue&type=style&index=0&id=17637522&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17637522",
  null
  
)

export default component.exports